import type { PropsWithChildren, ReactNode } from "react";

export function Eyebrow({ children, right }: PropsWithChildren<{ right?: ReactNode }>) {
  return (
    <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.16em] text-muted mb-3">
      <span>{children}</span>
      {right}
    </div>
  );
}
